import "/src/scss/components/_search-modal.scss";
import List from "list.js";
import debounce from "lodash/debounce";

(() => {
  const searchIcon = document.getElementById("search-icon");
  const panel = document.getElementById("search-modal");
  if (!searchIcon || !panel) return;

  const input = document.getElementById("search-modal-input");
  const resultsEl = document.getElementById("search-modal-results");
  const spinner = document.getElementById("search-modal-spinner");
  let searchList = null;

  function openSearch() {
    panel.hidden = false;
    searchIcon.setAttribute("aria-expanded", "true");
    if (!searchList) initSearchList();
    input.focus();
  }

  function closeSearch() {
    panel.hidden = true;
    searchIcon.setAttribute("aria-expanded", "false");
  }

  searchIcon.addEventListener("click", () => {
    if (panel.hidden) {
      openSearch();
    } else {
      closeSearch();
    }
  });

  // ESC schließt das Panel
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !panel.hidden) closeSearch();
  });

  // Klick außerhalb schließt das Panel (auch Klicks aufs SVG in der Lupe abfangen)
  document.addEventListener("click", (event) => {
    if (panel.hidden) return;
    if (
      !panel.contains(event.target) &&
      !searchIcon.contains(event.target)
    ) {
      closeSearch();
    }
  });

  function initSearchList() {
    searchList = new List(
      "search-modal-results",
      {
        valueNames: [{ attr: "href", name: "url" }, "title"],
        item: `<li><a href="" class="url"><p class="title"></p></a></li>`,
      },
      [],
    );

    input.addEventListener(
      "input",
      debounce(async (event) => {
        const value = event.target.value.trim();

        if (!value) {
          searchList.clear();
          resultsEl?.setAttribute("aria-busy", "false");
          return;
        }

        resultsEl?.setAttribute("aria-busy", "true");
        if (spinner) spinner.hidden = false;

        try {
          const res = await fetch(
            `/wp-json/wp/v2/search?search=${encodeURIComponent(value)}&per_page=20`,
          );
          const data = await res.json();
          searchList.clear();

          if (data.length) {
            data.forEach((result) => {
              searchList.add({
                url: result.url,
                title: result.title,
              });
            });
          } else {
            searchList.add({
              title: "Keine Ergebnisse gefunden",
              url: "#",
            });
          }
        } catch (err) {
          console.error("Search error:", err);
          searchList.clear();
          searchList.add({
            title: "Suche fehlgeschlagen. Bitte versuchen Sie es erneut.",
            url: "#",
          });
        } finally {
          if (spinner) spinner.hidden = true;
          resultsEl?.setAttribute("aria-busy", "false");
        }
      }, 300),
    );
  }
})();
